import { MonthDay } from '@/modules/common/types/month-day';

export enum TimeOffTypeCode {
  PAID_VACATION = 'PAID_VACATION',
  PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',
  SICK_LEAVE = 'SICK_LEAVE',
  UNPAID_TIME_OFF = 'UNPAID_TIME_OFF',
}

export enum TimeOffAllocationFormat {
  Yearly = 'YEARLY',
  Monthly = 'MONTHLY',
}

export interface TimeOffScheduledChange {
  effectiveStartDate: string;
  description?: string;
}

export type { MonthDay } from '@/modules/common/types/month-day';

export interface TimeOffType {
  id: number;
  code: TimeOffTypeCode;
  displayName: string;
  format: TimeOffAllocationFormat;
  allocationDays: number;
  dateOfRenewal: MonthDay;
  isApprovalRequired: boolean;
  scheduledChange?: TimeOffScheduledChange;
}

export interface TimeOffTypeDetails extends TimeOffType {
  allowCarryover: boolean;
  carryoverDays: number | null;
  allowNegativeBalance: boolean;
  negativeBalanceDays: number | null;
  hasMaxLimit: boolean;
  maxLimitDays: number | null;
  requireFileUpload: boolean;
  allowHalfDay: boolean;
  allowQuarterDay: boolean;
  allowHourlyRequests: boolean;
  considerMemberCapacity: boolean;
  isBillable: boolean;
  creditOnCreation: boolean;
  prorateAccrual: boolean;
}
